/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
const stringSets = {
	cs: require('../../translations/cs.json'),
	da: require('../../translations/da.json'),
	de: require('../../translations/de.json'),
	hu: require('../../translations/hu.json'),
	uk: require('../../translations/uk.json'),
	en: require('../../translations/en.json'),
	es: require('../../translations/es.json'),
	fi: require('../../translations/fi.json'),
	fr: require('../../translations/fr.json'),
	id: require('../../translations/id.json'),
	it: require('../../translations/it.json'),
	ja: require('../../translations/ja.json'),
	ko: require('../../translations/ko.json'),
	nb: require('../../translations/nb.json'),
	nl: require('../../translations/nl.json'),
	pl: require('../../translations/pl.json'),
	pt: require('../../translations/pt.json'),
	ru: require('../../translations/ru.json'),
	sv: require('../../translations/sv.json'),
	th: require('../../translations/th.json'),
	tr: require('../../translations/tr.json'),
	vi: require('../../translations/vi.json'),
	'zh-Hans': require('../../translations/zh-Hans.json'),
	'zh-Hant': require('../../translations/zh-Hant.json'),
};

// RelativeTimeFormat is needed for <FormattedRelativeTime> in TimeToTextformat.js specifically for IE11
if (!Intl.RelativeTimeFormat) {
	require('@formatjs/intl-relativetimeformat/polyfill');

	require('@formatjs/intl-relativetimeformat/locale-data/cs');

	require('@formatjs/intl-relativetimeformat/locale-data/da');

	require('@formatjs/intl-relativetimeformat/locale-data/de');

	require('@formatjs/intl-relativetimeformat/locale-data/hu');

	require('@formatjs/intl-relativetimeformat/locale-data/uk');

	require('@formatjs/intl-relativetimeformat/locale-data/en');

	require('@formatjs/intl-relativetimeformat/locale-data/es');

	require('@formatjs/intl-relativetimeformat/locale-data/fi');

	require('@formatjs/intl-relativetimeformat/locale-data/fr');

	require('@formatjs/intl-relativetimeformat/locale-data/id');

	require('@formatjs/intl-relativetimeformat/locale-data/it');

	require('@formatjs/intl-relativetimeformat/locale-data/ja');

	require('@formatjs/intl-relativetimeformat/locale-data/ko');

	require('@formatjs/intl-relativetimeformat/locale-data/nb');

	require('@formatjs/intl-relativetimeformat/locale-data/nl');

	require('@formatjs/intl-relativetimeformat/locale-data/pl');

	require('@formatjs/intl-relativetimeformat/locale-data/pt');

	require('@formatjs/intl-relativetimeformat/locale-data/ru');

	require('@formatjs/intl-relativetimeformat/locale-data/sv');

	require('@formatjs/intl-relativetimeformat/locale-data/th');

	require('@formatjs/intl-relativetimeformat/locale-data/tr');

	require('@formatjs/intl-relativetimeformat/locale-data/vi');

	require('@formatjs/intl-relativetimeformat/locale-data/zh');
}

// getCanonicalLocales is needed for intl.formatMessage specifically for IE11
// @ts-ignore
if (!Intl.getCanonicalLocales) {
	require('@formatjs/intl-getcanonicallocales/polyfill');
}

if (!Intl.PluralRules) {
	require('@formatjs/intl-pluralrules/polyfill');

	require('@formatjs/intl-pluralrules/dist/locale-data/cs');

	require('@formatjs/intl-pluralrules/dist/locale-data/da');

	require('@formatjs/intl-pluralrules/dist/locale-data/de');

	require('@formatjs/intl-pluralrules/dist/locale-data/hu');

	require('@formatjs/intl-pluralrules/dist/locale-data/uk');

	require('@formatjs/intl-pluralrules/dist/locale-data/en');

	require('@formatjs/intl-pluralrules/dist/locale-data/es');

	require('@formatjs/intl-pluralrules/dist/locale-data/fi');

	require('@formatjs/intl-pluralrules/dist/locale-data/fr');

	require('@formatjs/intl-pluralrules/dist/locale-data/id');

	require('@formatjs/intl-pluralrules/dist/locale-data/it');

	require('@formatjs/intl-pluralrules/dist/locale-data/ja');

	require('@formatjs/intl-pluralrules/dist/locale-data/ko');

	require('@formatjs/intl-pluralrules/dist/locale-data/nb');

	require('@formatjs/intl-pluralrules/dist/locale-data/nl');

	require('@formatjs/intl-pluralrules/dist/locale-data/pl');

	require('@formatjs/intl-pluralrules/dist/locale-data/pt');

	require('@formatjs/intl-pluralrules/dist/locale-data/ru');

	require('@formatjs/intl-pluralrules/dist/locale-data/sv');

	require('@formatjs/intl-pluralrules/dist/locale-data/th');

	require('@formatjs/intl-pluralrules/dist/locale-data/tr');

	require('@formatjs/intl-pluralrules/dist/locale-data/vi');

	require('@formatjs/intl-pluralrules/dist/locale-data/zh');
}

class LocaleUtils {
	static getLocaleStrings(appLocale: string): Record<string, any> {
		return stringSets[appLocale];
	}
}

export { LocaleUtils };
